import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmployerRoutingModule } from './employer-routing.module';
import { EmployerModuleComponent } from './employer.module.component';
import { EmployerLibraryModule, MaterialLibraryModule } from 'epay-library';
import { HelperLibraryModule } from 'epay-library';
import { CommonLibraryModule } from 'epay-library';
import { BaseLayoutModule } from '../layout/base-layout.module';
import { EMPHomeComponent } from './components/home/home.component';

import { EMPRegisterComponent } from './components/register/employer.register.component';
import { EMPACHDLandingComponent } from './components/achd/landing/achd.landing.component';
import { EMPCreditCardLandingComponent } from './components/creditcard/landing/creditcard.landing.component';
import { EMPCreditCardPaymentComponent } from './components/creditcard/payment/creditcard.payment.component';
import { EMPEFTCreateFileComponent } from './components/eft/createfile/createfile.component';
import { EMPEFTInformationComponent } from './components/eft/information/eft-information.component';
import { EMPEFTLandingComponent } from './components/eft/landing/eft.landing.component';
import { EMPProfileComponent } from './components/profile/profile.component';
import { EMPACHDInformationComponent } from './components/achd/information/achd-information.component';
import { EMPPaymentComponent } from './components/achd/payment/payment.component';
import { EMPPaymentAccountListComponent } from './components/achd/paymentaccount/paymentaccountlist.component';
import { EMPSecondaryRegistrationComponent } from './components/register/secondary-registration/secondary-registration.component';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMaskModule } from 'ngx-mask';
import { MaskDataPipe } from 'epay-library';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ngxInputRegulateModule } from 'ngx-input-regulate';
import { EmployerSecondaryRegistrationComponent } from './components/register/secondary-registration/employer-secondary-registration/employer-secondary-registration.component';
import { EmployerProfileSecurityComponent } from './components/profile/employer-profile-security/employer-profile-security.component';
import { EMPPaymentListCommonComponent } from './components/achd/landing/emppayment-list-common/emppayment-list-common.component';
import { EMPPaymentHistoryCommonComponent } from './components/achd/landing/emppayment-history-common/emppayment-history-common.component';
import { EpayCommonEmployerPaymentAcctListComponent } from './components/achd/paymentaccount/epay-common-employer-payment-acct-list/epay-common-employer-payment-acct-list.component';
import { EpayCommonEmployerPaymentAccountComponent } from './components/achd/paymentaccount/epay-common-employer-payment-acct-list/epay-common-employer-payment-account/epay-common-employer-payment-account.component';

@NgModule({
  declarations: [
    EmployerModuleComponent,
    EMPHomeComponent,
    EMPRegisterComponent,
    EMPACHDLandingComponent,
    EMPEFTLandingComponent,
    EMPProfileComponent,
    EMPPaymentComponent,
    EMPPaymentAccountListComponent,
    EMPSecondaryRegistrationComponent,
    EMPACHDInformationComponent,
    EMPEFTInformationComponent,
    EMPEFTCreateFileComponent,
    EMPCreditCardPaymentComponent,
    EMPCreditCardLandingComponent,
    EmployerSecondaryRegistrationComponent,
    EmployerProfileSecurityComponent,
    EMPPaymentListCommonComponent,
    EMPPaymentHistoryCommonComponent,
    EpayCommonEmployerPaymentAcctListComponent,
    EpayCommonEmployerPaymentAccountComponent,
  ],
  imports: [
    CommonModule,
    EmployerRoutingModule,
    EmployerLibraryModule,
    HelperLibraryModule,
    CommonLibraryModule,
    BaseLayoutModule,
    MatFormFieldModule,
    MaterialLibraryModule,
    ReactiveFormsModule,
    FormsModule,
    ngxInputRegulateModule,
    MatCardModule,
    MatTabsModule,
    MatTooltipModule,
    NgxMaskModule.forRoot(),
  ],
  providers: [MaskDataPipe],
})
export class EmployerModule {}
